import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
@Injectable({
    providedIn: 'root'
})
export class UtilityService {
    private currentDate = new Date();

    constructor(private datePipe: DatePipe) { }

    getDateWithoutTime(dateValue?: Date): Date {
        if (!dateValue) return new Date();
        return new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate());
    }

    private toDate(value: any): Date | null {
        if (!value) return null;
        const date = new Date(value);
        return isNaN(date.getTime()) ? null : date;
    }

    getMinTimeForEndTime(startDate: any, endDate: any, startTime: any): string | undefined {
        const start = this.toDate(startDate);
        const end = this.toDate(endDate);
        const currentWithoutTime = this.getDateWithoutTime(this.currentDate);

        if (start && end) {
            const startDay = this.getDateWithoutTime(start);
            const endDay = this.getDateWithoutTime(end);

            if (startDay.getTime() === endDay.getTime()) return startTime || '';
        }

        if (end) {
            const endDay = this.getDateWithoutTime(end);
            if (endDay.getTime() === currentWithoutTime.getTime()) {
                return this.datePipe.transform(this.currentDate, 'HH:mm') || '';
            }
        }

        return undefined;
    }

    isSameDate(date1: any, date2: any): boolean {
        const d1 = new Date(date1);
        const d2 = new Date(date2);
        return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }

    convertDateTime(date: Date, time: string = ''): string {
        if (!date) return '';

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toLocaleString('fr-FR', { minimumIntegerDigits: 2 });
        const day = date.getDate().toLocaleString('fr-FR', { minimumIntegerDigits: 2, useGrouping: false });

        return `${year}-${month}-${day}${time ? ' ' + time + ':00' : ''}`;
    }

}